export default class WSRoutes {
  private eb: any;
  private events: string[];
  constructor(websocketEvents: string[], eventBus: any) {
    this.eb = eventBus;
    this.events = websocketEvents;
  }

  public handleMessage(wsInstance: any, messageEvent: any) {
    const data = messageEvent.data;
    try {
      const json = JSON.parse(data);
      if (json.evt) {
        this.eb.$emit(json.evt, json.payload);
      } else {
        console.error('invalid websocket data:', json);
      }
    } catch (e) {
      console.log('failed to parse websocket message:', e.message);
    }
  }
}
